import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { cellHeight, cellYSpacing, gridCellRows, perMinuteCellSize } from './defaults';
import { useRealTime } from '@core/hooks';
import React, { useMemo } from 'react';

const RenderTimelineTrackerComponent = () => {
  const { now } = useRealTime();
  const offset = useMemo(() => now.minutes() * perMinuteCellSize, [now]);
  return (
    <React.Fragment>
      <div
        style={{
          top: 0,
          left: offset,
          position: 'absolute',
          height: gridCellRows * cellHeight + cellYSpacing * gridCellRows + cellHeight + 10,
          width: 3,
          zIndex: 3,
          backgroundColor: GLOBAL_THEME_COLOR.$highlight_color,
        }}></div>
      <div
        style={{
          top: 0,
          left: offset,
          zIndex: 4,
          backgroundColor: GLOBAL_THEME_COLOR.$highlight_color,
          position: 'absolute',
          color: GLOBAL_THEME_COLOR.$text_color_contrast,
          fontWeight: '500',
          padding: '1px 10px',
          borderRadius: 5,
          whiteSpace: 'nowrap',
        }}>
        <span>{now.format('hh:mm A')}</span>
      </div>
    </React.Fragment>
  );
};

export default RenderTimelineTrackerComponent;
